import { PollingManager } from './PollingManager';

export { MAX_RETRIES } from './Poller';

/**
 * usage:

    Polling.register({
      name: 'jobs-polling',
      interval: 5000,
      enableBackoffInterval: false,
      
      // using a polling URL
      url: Jobs.baseUrl,\
      callback: this.onGetJobs,
      useTimestamp: true,

      //or

      // using a service function
      // let errors bubble up for poller's retry
      serviceFunction: async () => {...}
    });
    
 *
 */
export const PollingService = new PollingManager();
